// src/index.tsx
// Entry point — mounts the React app into the DOM.
// No changes needed here beyond the default CRA output.

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initializeTheme } from "./context/ThemeContext";

initializeTheme();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
